import { FieldProps } from 'formik'
import * as React from 'react'

import { QuestionWrapper } from '../form.styles'
import { ErrorMessage, InputField, Label, Wrapper } from '../Input/Input.styles'

interface Props extends React.InputHTMLAttributes<any> {
  value?: any
  label: string
  name: string
  text?: string
  hasError?: boolean
  errorMsg?: string
  required?: boolean
  onInputChange?: (event) => void
}

interface State {
  hasFocus: boolean
  value: string
}

class PhoneInput extends React.Component<Props & FieldProps<any>, State> {
  constructor(props) {
    super(props)
    if (props.value) {
      this.state = { hasFocus: false, value: props.value }
    } else {
      const formValue = props.form.values[props.field.name]
      const value = formValue ? formValue : ''
      this.state = { hasFocus: false, value }
    }
  }

  onFocus = () => {
    this.setState({ hasFocus: true })
  }

  onBlur = () => {
    this.setState({ hasFocus: false })
  }

  onlyPhoneKeys = (event: React.KeyboardEvent) => {
    if (!'0123456789()- +'.includes(event.key)) {
      event.stopPropagation()
      event.preventDefault()
    }
  }

  onChange = event => {
    this.setState({ value: event.currentTarget.value })
    if (this.props.onInputChange) this.props.onInputChange(event)
    this.props.form.handleChange(event)
  }

  render() {
    const { label, text, required = false, field, form } = this.props
    const value = this.state.value
    const hasValue = Boolean(
      value && typeof value === 'string' && value.trim().length > 0,
    )
    const hasError = Boolean(
      (form.touched[field.name] || hasValue) && form.errors[field.name],
    )

    const { hasFocus } = this.state

    return (
      <>
        {text && (
          <QuestionWrapper as="div" color="black">
            {text}
          </QuestionWrapper>
        )}
        <Wrapper>
          <Label required={required} elevated={hasValue || hasFocus}>
            {label}
          </Label>
          <InputField
            name={field.name}
            type="text"
            value={this.state.value}
            onChange={this.onChange}
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onKeyPress={this.onlyPhoneKeys}
            hasError={hasError}
          />
        </Wrapper>
        {hasError && form.submitCount > 0 && (
          <ErrorMessage>{form.errors[field.name]}</ErrorMessage>
        )}
      </>
    )
  }
}

export default PhoneInput
